module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__cl_banco_scotiabank_Min.802812fd.svg";